import { z } from 'zod';

export const lockerSchema = z.object({
  id: z.string(),
  name: z.string(),
  size: z.string(),
  status: z.string(),
  time: z.string().datetime({ offset: true }).or(z.literal('')),
  houseNumber: z.string()
});

export type Locker = z.infer<typeof lockerSchema>;
